// eslint-disable-next-line no-restricted-imports
import { Button as AntdButton, type GetRef } from 'antd'
import { type ButtonType } from 'antd/es/button'
import clsx from 'clsx'
import { type ComponentPropsWithRef, forwardRef } from 'react'

type Props = Omit<ComponentPropsWithRef<typeof AntdButton>, 'type'> & {
  /** ボタンタイプ */
  type?: ButtonType | 'secondary' | 'info'
}

/**
 * Antd の Button をラップしたコンポーネント
 * - type に Secondary | info を追加
 * - アイコンのサイズを12pxに変更
 */
export const Button = forwardRef<GetRef<typeof AntdButton>, Props>(
  ({ className, children, type, size, ...props }, ref) => {
    const isSecondary = type === 'secondary'
    const isInfo = type === 'info'

    return (
      <AntdButton
        ref={ref}
        {...props}
        size={size}
        className={clsx([
          '',
          isSecondary &&
            'bg-secondary text-white hover:!bg-secondary-hover active:!bg-secondary-active',
          isInfo &&
            'bg-info text-white hover:!bg-info-hover active:!bg-info-active',
          className
        ])}
        classNames={{
          icon: clsx(['!text-xs'])
        }}
        type={isSecondary || isInfo ? 'primary' : type}
      >
        {children}
      </AntdButton>
    )
  }
)
